import { ServiceRequest } from './service-request';

export class CreateRequest extends ServiceRequest {


}
